import ScrollingBanner from '../ScrollingBanner'


const HomePage = props =>  (
  <div className="content">
    <div><h3>{props.t('common:home_main-disclaimer')}</h3></div>
    { props.scrollingBanner &&
      <ScrollingBanner
        text={props.language === 'en' ? props.scrollingBanner.english_text : props.scrollingBanner.french_text}
        isActive={props.scrollingBanner.is_active}
      />
    }
    <img src="/static/images/image003.jpg" />
    <div className="m-b-md m-t-sm">{props.t('common:home_subscriptions-menu-item-5')}</div>
    <div className="m-b-lg"><blockquote>{props.t('common:home_main-content')}</blockquote></div>
    <p>{props.t('common:home_subscription-header')}</p>
    <ul>
      <li>{props.t('common:home_subscriptions-menu-item-1')}</li>
      <li>{props.t('common:home_subscriptions-menu-item-2')}</li>
      <li>{props.t('common:home_subscriptions-menu-item-3')}</li>      
    </ul>
  </div>
)

export default HomePage



// WEBPACK FOOTER //
// ./components/Home/index.js